/**
 * Phase 06.2 / DEC-033 #3 — tenant overlay for the platform site_types catalog.
 *
 * Tenant-scoped: RLS-isolated via tenant_id. Composite PK (tenant_id, site_type_id).
 * is_enabled BOOLEAN NOT NULL DEFAULT true.
 *
 * Auto-populated for each tenant on tenant creation — every existing site_types
 * row gets a settings row with is_enabled=true (Plan 06.2-07 tenant-creation hook).
 *
 * GET /v1/site-types (Plan 06.2-12) INNER JOINs site_types + this table to
 * return only the active+enabled types for the current tenant.
 */

import { pgTable, uuid, boolean, timestamp, pgPolicy, primaryKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

import { appUserRole } from './enums.js';
import { tenants } from './users.js';
import { siteTypes } from './site-types.js';

export const tenantSiteTypeSettings = pgTable(
  'tenant_site_type_settings',
  {
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    siteTypeId: uuid('site_type_id')
      .notNull()
      .references(() => siteTypes.id, { onDelete: 'cascade' }),
    isEnabled: boolean('is_enabled').notNull().default(true),
    updatedAt: timestamp('updated_at', { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [
    primaryKey({ columns: [t.tenantId, t.siteTypeId] }),
    pgPolicy('tenant_site_type_settings_isolation', {
      as: 'permissive',
      to: appUserRole,
      for: 'all',
      using: sql`tenant_id = current_setting('app.current_tenant_id')::uuid`,
    }),
  ],
);

export type TenantSiteTypeSetting = typeof tenantSiteTypeSettings.$inferSelect;
export type NewTenantSiteTypeSetting = typeof tenantSiteTypeSettings.$inferInsert;
